import { ReactNode } from "react";

import { Header } from "./components";
import { StyledContentWrapper, StyledMainLayout } from "./styles";

type LayoutProps = {
  children: ReactNode;
};

function Layout({ children }: LayoutProps): JSX.Element {
  return (
    <StyledMainLayout>
      <Header />
      <StyledContentWrapper>{children}</StyledContentWrapper>
    </StyledMainLayout>
  );
}

export default Layout;
